import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';

/** Job service (polling/sessionStorage/download) da Composição Efetiva do órgão/delegacia. */
@Injectable({ providedIn: 'root' })
export class ComposicaoOrgaoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'composicao-orgao-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.orgao.reports.composicao;
}
